import { ShieldAlert, ShieldCheck } from "lucide-react";

export function VerifyTag({ ok, testId }: { ok: boolean; testId: string }) {
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1 rounded-sm border px-1.5 py-0.5 font-sans text-[10px] font-semibold uppercase tracking-wider ${ok ? "border-emerald-600/40 bg-emerald-50 text-emerald-700" : "border-amber-500/50 bg-amber-50 text-amber-700"}`}>
      {ok ? <ShieldCheck aria-hidden="true" className="h-3 w-3" /> : <ShieldAlert aria-hidden="true" className="h-3 w-3" />}
      {ok ? "verificado" : "a verificar"}
    </span>
  );
}
